<template>
    <div class="createTest">
        <div class="createTest-header">
            <h1> {{ getFlagReadonly ? 'Просмотр' : $route.params.id === 'new' ? 'Создание' : 'Редактирование' }} теста</h1>
            <div class="header-btn">

                <v-tooltip bottom v-if="tab === 0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-if="tab === 0 && !getFlagReadonly"
                            v-bind="attrs"
                            v-on="on"
                            :loading="loadingRefreshDiaTestProperties"
                            large
                            class="custom-button"
                            @click.prevent="updateDialog"
                        >
                            Обновить
                        </v-btn>
                    </template>
                    <div>При обновлении теста будет обновлен эпизод жизни,<br>на основании которого создан данный тест</div>
                </v-tooltip>
                <v-btn large class="custom-button" @click.prevent="closeTest">Закрыть тест</v-btn>
            </div>
        </div>
        <div class="createTest-tabs">
            <v-tabs v-model="tab" align-with-title>
                <v-tab v-for="(item, key) in items" :key="key" :disabled="!item.view" :class="{ 'tab-disabled': !item.view }">
                    {{ item.name }}

                    <div v-if="item.id === 5 && tab === 4" class="ml-2">
                        <v-tooltip top content-class="custom-tooltip">
                            <template v-slot:activator="{ on, attrs }">
                                <svg v-bind="attrs" v-on="on" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="24" height="24" rx="12" fill="#717BF9"/>
                                    <path d="M11.0568 18V9.27273H13.1136V18H11.0568ZM12.0909 8.03409C11.7652 8.03409 11.4848 7.92614 11.25 7.71023C11.0152 7.49053 10.8977 7.22727 10.8977 6.92045C10.8977 6.60985 11.0152 6.34659 11.25 6.13068C11.4848 5.91098 11.7652 5.80114 12.0909 5.80114C12.4205 5.80114 12.7008 5.91098 12.9318 6.13068C13.1667 6.34659 13.2841 6.60985 13.2841 6.92045C13.2841 7.22727 13.1667 7.49053 12.9318 7.71023C12.7008 7.92614 12.4205 8.03409 12.0909 8.03409Z" fill="white" fill-opacity="0.97"/>
                                </svg>
                            </template>
                            <div class="info-tooltip">Сумма баллов по всем <br> критериям должна <br> равняться 100 </div>
                        </v-tooltip>
                    </div>
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item v-for="(item, key) in items" :key="key">
                    <div v-if="item.name == 'Основная информация'" class="tab-item">
                        <v-form v-model="validG" ref="formGeneral" lazy-validation>
                            <div class="item-combo">
                                <p>Вид теста*</p>
                                <v-autocomplete
                                    label=""
                                    hide-details
                                    outlined
                                    class="item-combo__select"
                                    :items="passTypes"
                                    item-value="id"
                                    item-text="name"
                                    v-model="getGeneralData.passTypeId"
                                    :readonly="getFlagReadonly"
                                    required
                                    :rules="[rules.required]"
                                    :loading="loadingPassTypes || loadingData"
                                    @focus="getPassTypes()"
                                />
                            </div>
                            <div class="item-combo">
                                <p>Название теста*</p>
                                <v-text-field :readonly="getFlagReadonly" :rules="[rules.required, rules.maxSymbol]" :loading="loadingData" outlined v-model="getGeneralData.title" type="text" placeholder="Введите название теста" />
                            </div>
                            <div class="item-combo">
                                <p>Описание</p>
                                <v-textarea :readonly="getFlagReadonly" :rules="[rules.maxSymbol]" :loading="loadingData" outlined v-model="getGeneralData.description" cols="30" rows="4" placeholder="Описание" />
                            </div>
                            <div class="tab-container">
                                <div class="item-combo">
                                    <p>Дисциплина*</p>
                                    <v-autocomplete
                                        label=""
                                        outlined
                                        :rules="[rules.required]"
                                        :readonly="getFlagReadonly"
                                        @focus="getSpr('get', 'api/SprStudyDiscipline/GetAll', 'itemsDiscipline', 'loadingDescipline')"
                                        :items="itemsDiscipline"
                                        :loading="loadingDescipline || loadingData"
                                        placeholder="Выбрать дисциплину"
                                        item-text="name"
                                        item-value="id"
                                        class="item-combo__select"
                                        v-model="getGeneralData.studyDisciplineId"
                                    />
                                </div>
                                <div class="item-combo">
                                    <p>Тема*</p>
                                    <v-autocomplete
                                        label=""
                                        outlined
                                        :rules="[rules.required]"
                                        :readonly="getFlagReadonly"
                                        @focus="getSpr('get', 'api/SprStudyTopic/GetAll', 'itemsTopic', 'loadingTopic')"
                                        :items="itemsTopic"
                                        :loading="loadingTopic || loadingData"
                                        placeholder="Выбрать тему"
                                        item-text="name"
                                        item-value="id"
                                        class="item-combo__select"
                                        v-model="getGeneralData.studyTopicId"
                                    />
                                </div>
                                <div class="item-combo">
                                    <p>Время прохождения*</p>
                                    <div class="item-wrap">
                                        <div class="time">
                                            <v-text-field :readonly="getFlagReadonly" :rules="[rules.required, rules.minMax(hours, 0, 23), rules.isCeil(hours)]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" :loading="loadingData" outlined class="item-input" v-model="hours" type="number" placeholder="часа(ов)" /> ч
                                        </div>
                                        <div class="time">
                                            <v-text-field :readonly="getFlagReadonly" :rules="[rules.required, rules.minMax(minutes, 0, 59), rules.isCeil(minutes)]" onkeypress="return event.charCode >= 48 && event.charCode <= 57" :loading="loadingData" outlined class="item-input" v-model="minutes" type="number" placeholder="минут(ы)" /> мин.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                        <div class="btn-save" v-if="!getFlagReadonly">
                            <v-btn :loading="loadingSaveGeneralInfo" class="btn-save__outline custom-button" large color="outline-primary" @click="saveConstructor('formGeneral', 'saveGeneralInformation', 'loadingSaveGeneralInfo', getGeneralData)">Сохранить</v-btn>
                        </div>
                    </div>
                    <div v-if="item.name == 'Виртуальный пациент'" class="tab-item">
                        <v-form v-model="validV" ref="formVirtual" lazy-validation>
                            <div class="tab-container">
                                <div class="item-combo">
                                    <p>ФИО*</p>
                                    <v-autocomplete
                                        label=""
                                        :rules="[rules.required]"
                                        outlined
                                        @focus="getSpr('post', 'Patient/GetAll', 'itemsPatients', 'loadingPatients', paramsDefault)"
                                        :items="itemsPatients"
                                        :loading="loadingPatients"
                                        item-text="fio"
                                        item-value="id"
                                        class="item-combo__select"
                                        v-model="getVirtualPatient.patientId"
                                        :readonly="items[2].view || getFlagReadonly"
                                    />
                                </div>
                                <div class="item-combo">
                                    <p>Эпизод жизни*</p>
                                    <v-autocomplete
                                        label=""
                                        outlined
                                        :rules="[getVirtualPatient.patientId ? rules.required : true]"
                                        :readonly="!getVirtualPatient.patientId || getFlagReadonly"
                                        :placeholder="getVirtualPatient.patientId ? 'Выберите эпизод' : 'Выберите пациента, чтобы разблокировать поле'"
                                        @focus="getVirtualPatient.patientId ? getSpr('get', `Patient/Get?id=${getVirtualPatient.patientId}`, 'itemsEpisode', 'loadingEpisode') : ''"
                                        :items="itemsEpisode"
                                        :loading="loadingEpisode"
                                        item-text="name"
                                        item-value="id"
                                        class="item-combo__select"
                                        v-model="getVirtualPatient.episodeId"
                                        :disabled="items[2].view"
                                    />
                                </div>
                            </div>
                        </v-form>
                        <div class="btn-save" v-if="!getFlagReadonly">
                            <v-btn v-if="!items[2].view" :loading="loadingSave" class="btn-save__outline custom-button" large color="outline-primary" @click="saveConstructor('formVirtual', 'addVirtualInformation', 'loadingSave', getVirtualPatient)">Сохранить</v-btn>
                        </div>
                    </div>
                    <div v-if="item.name == 'Показатели'" class="tab-item">
                        <Indicators />
                    </div>
                    <div v-if="item.name == 'Диагностика'" class="tab-item indic">
                        <Diagnostics />
                    </div>
                    <div v-if="item.name == 'Критерии оценки'" class="tab-item">
                        <Criteria />
                    </div>
                </v-tab-item>
            </v-tabs-items>
        </div>

        <v-dialog v-model="dialogUpdate" scrollable max-width="600px" persistent>
            <v-card>
                <v-card-title>Новые показатели</v-card-title>
                <v-divider></v-divider>

                <v-card-text style="height: 500px; justify-content: left; flex-direction: column; align-items: normal">
                    <div
                        v-show="listNewTestProperty"
                        v-for="(item, key) in listNewTestProperty"
                        :key="'a'+key"
                        class="mb-4"
                    >
                        <h4 class="mb-2 black--text">
                            {{ key == 'null' ? 'Общий осмотр' : key}}
                        </h4>

                        <div
                            v-for="(it, ind) in item"
                            :key="'B'+ind"
                            class="stroke-property"
                        >
                            <p class="pl-2">
                                <span v-if="it.value">
                                    {{ it.indicatorName }}: {{ it.value }} {{ it.measurementName }}
                                </span>
                                <span v-else>
                                    {{ it.indicatorName }}
                                </span>
                            </p>

                            <div class="stroke-property__actions">
                                <v-btn
                                    @click="it.isVisible = !it.isVisible"
                                    :title="it.isVisible ? 'Скрыть' : 'Показать'"
                                    icon
                                    small
                                >
                                    <v-icon>
                                        {{ it.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}
                                    </v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="justify-center">
                    <v-btn :loading="loadingUpdateEpisode" large dark color="#4854FE" @click="saveUpdateEpisode(listNewProperty)">Сохранить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Diagnostics from './Diagnostics/index.vue'
import Indicators from './Indicators/index.vue'
import Criteria from './Criteria/index.vue'
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue'
import './index.scss';


export default {
    name: 'CreateTest',
    components: {Diagnostics, Indicators, Criteria, TimeoutSnackbar},
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl',
            getGeneralData: 'createDiagnosticTest/getGeneralData',
            getVirtualPatient: 'createDiagnosticTest/getVirtualPatient',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly',
            userInfo: 'user/userInfo'
        }),
        clientHeight() {
            return this.clientH
        },
        isChecked(){
            return localStorage.getItem('roles')
        }
    },
    data() {
        return {
            loadingUpdateEpisode: false,
            listNewProperty: null,
            listNewTestProperty: null,
            loadingRefreshDiaTestProperties: false,
            dialogUpdate: false,
            showInfoCriteria: false,
            validG: false,
            validV: false,
            loadingSave: false,
            loadingSaveGeneralInfo: false,
            loadingData: false,
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            itemsDiscipline: [],
            loadingDescipline: false,
            itemsTopic: [],
            loadingTopic: false,
            passTypes: [],
            loadingPassTypes: false,
            itemsPatients: [],
            loadingPatients: false,
            itemsEpisode: [],
            loadingEpisode: false,
            paramsDefault: {
                filters: [],
                sortOption: {
                    fieldName: "fio",
                    sortType: 1
                },
                pageSize: 999,
                currentPage: 0,
                useANDoperator: true,
                columns: []
            },
            hours: null,
            minutes: null,
            items: [
                { id: 1, name: 'Основная информация', view: true },
                { id: 2, name: 'Виртуальный пациент', view: false },
                { id: 3, name: 'Показатели', view: false },
                { id: 4, name: 'Диагностика', view: false },
                { id: 5, name: 'Критерии оценки', view: false }
            ],
            rules: {
                required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
                minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.',
                isCeil: (v) => (String(v).split('.').length === 1 && String(v).split(',').length === 1) || 'Число должно быть целым.',
                maxSymbol: (v) => v.length <= 220 || 'Максимум 220 символов.'
            },
            clientH: 688,
            tab: 0
        }
    },
    methods: {
        ...mapActions({
            saveGeneralInformation: 'createDiagnosticTest/saveGeneralInformation',
            addVirtualInformation: 'createDiagnosticTest/addVirtualInformation',
            getGeneralInformation: 'createDiagnosticTest/getGeneralInformation',
            getVirtualInformation: 'createDiagnosticTest/getVirtualInformation',
            getAnthropometricIndicators: 'createDiagnosticTest/getAnthropometricIndicators',
            getVitalIndicators: 'createDiagnosticTest/getVitalIndicators',
            refreshDiaTestProperties: 'createDiagnosticTest/refreshDiaTestProperties',
            updateVisibleForNewIndicators: 'createDiagnosticTest/updateVisibleForNewIndicators'
        }),
        ...mapMutations({
            resetGeneralData: 'createDiagnosticTest/resetGeneralData',
            saveInfoPatientForIndicators: 'createDiagnosticTest/saveInfoPatientForIndicators',
            addDiaTestIdForVP: 'createDiagnosticTest/addDiaTestIdForVP',
            checkViewOrNo: 'createDiagnosticTest/checkViewOrNo'
        }),
        showShadow() {
            const el = document.getElementsByTagName("html")
            // console.log(el);
            // el.classList.add("shadowScroll")
        },
        getSpr(type, url, name, loading, params) {
            if(name === 'itemsEpisode') this[name] = [];
            if(name !== 'itemsEpisode' && this[name].length > 0) {
                return;
            }

            this[loading] = true;

            return new Promise((resolve, reject) => {
                this.$http[type](`${this.apiUrl}${url}`, params ? params : undefined)
                    .then((res) => {
                        let data = type === 'post' ? res.data.data : (name === 'itemsEpisode' ? res.data.episodes : res.data);

                        this[name] = data;
                        this[loading] = false;
                        resolve(res)
                    })
                    .catch((error) => {
                        if(error) reject(error)
                    })
            })

        },
        closeTest(){
            if (this.isChecked === 'Teacher') {
                this.$router.push({ name: 'tasks' })
            }
            else{
                this.$router.push({ name: 'TestTasks' })
            }
        },
        updateDialog() {
            this.loadingRefreshDiaTestProperties = true;

            this.refreshDiaTestProperties(this.$route.params.id)
                .then((response) => {
                    this.listNewProperty = response;

                    let allArray = [
                        ...response.anthropometricIndicators,
                        ...response.instrumentalResearches,
                        ...response.labResearches,
                        ...response.somaticStatuses,
                        ...response.vitalIndicators
                    ];

                    if(allArray.length > 0) {
                        this.listNewTestProperty = Object.groupBy(allArray, ({ groupName }) => groupName);
                        this.dialogUpdate = true;
                    }

                    if(allArray.length === 0) {
                        this.snackbar = {
                            text: 'Новые данные не обнаружены!',
                            color: 'warning',
                            timeout: 4000,
                            show: true
                        };
                    }

                    this.loadingRefreshDiaTestProperties = false;
                })
        },
        saveUpdateEpisode(object) {
            this.loadingUpdateEpisode = true;
            this.updateVisibleForNewIndicators(object)
                .then(() => {
                    this.snackbar = {
                        text: 'Тест успешно обновлен!',
                        color: 'success',
                        timeout: 3000,
                        show: true
                    };

                    setTimeout(() => {
                        this.loadingUpdateEpisode = false;
                        this.dialogUpdate = false;

                        location.reload();
                    }, 2000)
                })
                .catch((error) => {
                    if (error) {
                        this.snackbar = {
                            text: 'При обновлении теста произошла ошибка, обратитесь к Администратору!',
                            color: 'error',
                            timeout: 3000,
                            show: true
                        };
                    }
                })
        },
        saveConstructor(formName, apiName, loadName, obj) {
            if(this.$refs[formName][0].validate()) {
                this[loadName] = true;

                if(formName === 'formGeneral') {
                    obj.minutes = this.calculateMinutes(+this.hours, +this.minutes);
                } else {
                    this.addDiaTestIdForVP(this.$route.params.id);
                }

                this[apiName](obj)
                    .then((res) => {

                        if(formName === 'formGeneral') {
                            this.snackbar = {
                                text: `Данные успешно сохранены${this.items[1].view ? '' : ', вкладка "Виртуальный пациент" открыта'}!!!`,
                                color: 'success',
                                timeout: 5000,
                                show: true
                            };

                            // Если это новый тест
                            if(this.checkNewTest(this.$route.params.id)) {
                                this.$router.replace(`/lk/test-tasks-diagnostic/${res.id}`)

                                // Открыть вкладку Виртуальный пациент
                                this.items[1].view = true;
                            }
                        }

                        if(formName === 'formVirtual') {
                            this.snackbar = {
                                text: `Данные успешно сохранены${this.items[2].view ? '' : ', вкладки "Показатели", "Диагностика", "Критерии оценки" открыты'}!!!`,
                                color: 'success',
                                timeout: 5000,
                                show: true
                            };

                            this.items[2].view = true;
                            this.items[3].view = true;
                            this.items[4].view = true;

                            if (this.getVirtualPatient.patientId) {
                                this.getPatient(this.getVirtualPatient.patientId, this.getVirtualPatient.episodeId);
                            }
                        }

                        this[loadName] = false;
                    })
            } else {
                this.snackbar = {
                    text: 'Корректно заполните обязательные поля!!!',
                    color: 'warning',
                    timeout: 5000,
                    show: true
                };
            }
        },
        calculateMinutes(h = 0, m = 0) {
            return h * 60 + m;
        },
        checkNewTest(string) {
            if(string === 'new') return true

            return false
        },
        getGeneral() {
            this.items[1].view = true;
            this.loadingData = true;

            this.getSpr('get', 'api/SprStudyDiscipline/GetAll', 'itemsDiscipline', 'loadingDescipline');
            this.getSpr('get', 'api/SprStudyTopic/GetAll', 'itemsTopic', 'loadingTopic');
            this.getPassTypes();

            this.getGeneralInformation(this.$route.params.id)
                .then((res) => {
                    if(res.minutes > 0) {
                        let h = res.minutes / 60 ^ 0;
                        if (h) {
                            let m = res.minutes % 60;
                            this.hours = h;
                            this.minutes = m;
                        } else {
                            this.minutes = res.minutes;
                        }
                    }

                    this.loadingData = false;
                })
        },
        getPassTypes() {
            this.loadingPassTypes = true;

            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((result) => {
                    this.passTypes = result.data;
                    this.loadingPassTypes = false;
            });
        },
        getVirtualPatients() {
            this.getSpr('post', 'Patient/GetAll', 'itemsPatients', 'loadingPatients', this.paramsDefault);

            this.getVirtualInformation(this.$route.params.id)
                .then((res) => {
                    this.getPatient(res.patientId, res.episodeId);

                    if(res.id) {
                        this.items[2].view = true;
                        this.items[3].view = true;
                        this.items[4].view = true;
                    }
                })
        },
        getPatient(patientId, episodeId) {
            this.getSpr('get', `Patient/Get?id=${patientId}`, 'itemsEpisode', 'loadingEpisode')
                .then((patient) => {
                    let episode = patient.data.episodes.find(x => x.id === episodeId);

                    if (episode) {
                        this.savePatient(patient.data, episode);
                    } else {
                        this.$http.get(`${this.apiUrl}Patient/GetPatientEpisode?id=${episodeId}&getDeleted=true`)
                            .then((result) => {
                                episode = result.data;
                                this.itemsEpisode.push(episode);
                                this.savePatient(patient.data, episode);
                            });
                    }
                });
        },
        savePatient(patient, episode) {
            this.saveInfoPatientForIndicators({
                fio: patient.fio,
                logoUrl: patient.logoUrl,
                birthday: patient.birthday,
                gender: patient.gender,
                episodeAge: episode.ageText
            });
        }
    },
    created() {
        // console.log(localStorage.getItem('roles'));
        if(this.$route.query.view) {
            this.checkViewOrNo(true);
        } else {
            this.checkViewOrNo(false);
        }
        // Если это новый тест то очищаем поля, иначе запрашиваем данные по id
        if(this.checkNewTest(this.$route.params.id)) {
            this.resetGeneralData();
        } else {
            this.getGeneral();
            this.getVirtualPatients()
        }

        this.clientH = window.innerHeight;
    }
}
</script>

<style>
.v-tooltip__content.menuable__content__active, .custom-tooltip {
    background: #717BF9 !important;
    opacity: 1 !important;
}
</style>